// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"B8-z","button":"C8-z","disabled":"D8-z","creditCard":"E8-z","wrapper":"F8-z"};